
export default {
  name: 'TheTabs',
  props: {
    value: {
      type: [String, Number],
      required: true
    },

    tabs: {
      type: Array,
      required: true
    },

    isHideCompleted: {
      type: Boolean,
      required: true
    }
  },

  computed: {
    selectedBlock: {
      get() {
        return this.value
      },

      set(id) {
        this.$emit('input', id)
      }
    }
  },

  methods: {
    selectBlock(id) {
      this.selectedBlock = id
    },

    checkIsTabSelected(id) {
      return this.selectedBlock === id
    },

    getOverflowTitle(e, title) {
      const tab = e.target
      const tabText = tab?.firstElementChild || null

      if (tabText && tabText.scrollWidth > tabText.offsetWidth) {
        tab.setAttribute('title', title)
      } else if (tab && tab.hasAttribute('title')) {
        tab.removeAttribute('title')
      }
    }
  }
}
